import { initializeSessionPrivacy } from "./lib/session_privacy";
import EmailRecipientsController from "./controllers/email_recipients_controller";
import CrmEmbedController from "./controllers/crm_embed_controller";
import TicketFollowUpDateController from "./controllers/ticket_follow_up_date_controller";
import TicketHoldController from "./controllers/ticket_hold_controller";
import DemoLaunchController from "./controllers/demo_launch_controller";
import PropertyLotPanelController from "./controllers/property_lot_panel_controller";
import TicketWaitEditController from "./controllers/ticket_wait_edit_controller";
import TicketAdminPanelController from "./controllers/ticket_admin_panel_controller";
import EmailAutosaveController from "./controllers/email_autosave_controller";
import AgencyProceduresController from "./controllers/agency_procedures_controller";
import AccountSaveStatusController from "./controllers/account_save_status_controller";
import { Application, Controller } from "@hotwired/stimulus";
import TicketByEmailRedirectController from "./controllers/ticket_by_email_redirect_controller";
import TicketChatActivityController from "./controllers/ticket_chat_activity_controller";
import TicketChatAttachmentsController from "./controllers/ticket_chat_attachments_controller";
import TicketChatComposerController from "./controllers/ticket_chat_composer_controller";
import TicketChatFragmentRefreshController from "./controllers/ticket_chat_fragment_refresh_controller";
import TicketChatMentionsController from "./controllers/ticket_chat_mentions_controller";
import TicketChatPaneController from "./controllers/ticket_chat_pane_controller";
import TicketChatThinkingController from "./controllers/ticket_chat_thinking_controller";
import TicketDetailLangfuseController from "./controllers/ticket_detail_langfuse_controller";
import TicketTeamChatReadController from "./controllers/ticket_team_chat_read_controller";
import TicketEmailDebugController from "./controllers/ticket_email_debug_controller";
import TicketEmailFrameController from "./controllers/ticket_email_frame_controller";
import TicketCloseController from "./controllers/ticket_close_controller";
import TicketInlineEditController from "./controllers/ticket_inline_edit_controller";
import TicketTriggerEmailsLazyController from "./controllers/ticket_trigger_emails_lazy_controller";
import TicketTriggerEmailPrefetchController from "./controllers/ticket_trigger_email_prefetch_controller";
import TicketMobilePanesController from "./controllers/ticket_mobile_panes_controller";
import TicketSelectionController from "./controllers/ticket_selection_controller";
import TicketSearchController from "./controllers/ticket_search_controller";
import TicketSplitterController from "./controllers/ticket_splitter_controller";
import AdminDialogController from "./controllers/admin_dialog_controller";
import AgentModelSettingsController from "./controllers/agent_model_settings_controller";
import OrganizationInviteController from "./controllers/organization_invite_controller";
import InlineEditController from "./controllers/inline_edit_controller";
import FormConfirmController from "./controllers/form_confirm_controller";
import IntakeQrController from "./controllers/intake_qr_controller";
import McpSetupController from "./controllers/mcp_setup_controller";
import IntakePhotoPickerController from "./controllers/intake_photo_picker_controller";
import RowLinkController from "./controllers/row_link_controller";
import ListFilterController from "./controllers/list_filter_controller";
import PmsCollectionController from "./controllers/pms_collection_controller";
import TableColumnsController from "./controllers/table_columns_controller";
import SidebarNavigationController from "./controllers/sidebar_navigation_controller";
import SidebarTicketBadgeController from "./controllers/sidebar_ticket_badge_controller";
import CookieBannerController from "./controllers/cookie_banner_controller";
import SignupTermsController from "./controllers/signup_terms_controller";
import AccountOutboundSignatureEditorController from "./controllers/account_outbound_signature_editor_controller";
import PasswordMinimumHintController from "./controllers/password_minimum_hint_controller";
import PasswordToggleController from "./controllers/password_toggle_controller";
import LandingController from "./controllers/landing_controller";
import GlobalAssistantController from "./controllers/global_assistant_controller";
import GlobalAssistantSplitterController from "./controllers/global_assistant_splitter_controller";
import ChangelogScrollController from "./controllers/changelog_scroll_controller";
import PropertySectionController from "./controllers/property_section_controller";
import ChangelogVideoController from "./controllers/changelog_video_controller";
import DelayedRedirectController from "./controllers/delayed_redirect_controller";
import TicketOverflowMarqueeController from "./controllers/ticket_overflow_marquee_controller";


initializeSessionPrivacy();
const application = Application.start();
for (const [identifier, controller] of Object.entries({
  "account-save-status": AccountSaveStatusController,
  "agency-procedures": AgencyProceduresController,
  "inline-edit": InlineEditController,
  "form-confirm": FormConfirmController,
  "crm-embed": CrmEmbedController,
  "intake-qr": IntakeQrController,
  "mcp-setup": McpSetupController,
  "intake-photo-picker": IntakePhotoPickerController,
  "row-link": RowLinkController,
  "property-lot-panel": PropertyLotPanelController,
  "list-filter": ListFilterController,
  "pms-collection": PmsCollectionController,
  "table-columns": TableColumnsController,
  "ticket-hold": TicketHoldController,
  "ticket-follow-up-date": TicketFollowUpDateController,
  "ticket-admin-panel": TicketAdminPanelController,
  "ticket-attachment-preview": TicketChatAttachmentsController,
  "ticket-by-email-redirect": TicketByEmailRedirectController,
  "ticket-chat-activity": TicketChatActivityController,
  "ticket-chat-attachments": TicketChatAttachmentsController,
  "ticket-chat-composer": TicketChatComposerController,
  "ticket-chat-fragment-refresh": TicketChatFragmentRefreshController,
  "ticket-chat-mentions": TicketChatMentionsController,
  "ticket-chat-pane": TicketChatPaneController,
  "ticket-chat-thinking": TicketChatThinkingController,
  "ticket-detail-langfuse": TicketDetailLangfuseController,
  "ticket-team-chat-read": TicketTeamChatReadController,
  "ticket-email-debug": TicketEmailDebugController,
  "ticket-email-frame": TicketEmailFrameController,
  "ticket-inline-edit": TicketInlineEditController,
  "ticket-wait-edit": TicketWaitEditController,
  "ticket-close": TicketCloseController,
  "email-autosave": EmailAutosaveController,
  "email-recipients": EmailRecipientsController,
  "ticket-trigger-emails-lazy": TicketTriggerEmailsLazyController,
  "ticket-trigger-email-prefetch": TicketTriggerEmailPrefetchController,
  "ticket-mobile-panes": TicketMobilePanesController,
  "ticket-selection": TicketSelectionController,
  "ticket-search": TicketSearchController,
  "ticket-splitter": TicketSplitterController,
  "admin-dialog": AdminDialogController,
  "demo-launch": DemoLaunchController,
  "agent-model-settings": AgentModelSettingsController,
  "organization-invite": OrganizationInviteController,
  "sidebar-navigation": SidebarNavigationController,
  "sidebar-ticket-badge": SidebarTicketBadgeController,
  "cookie-banner": CookieBannerController,
  "signup-terms": SignupTermsController,
  "account-outbound-signature-editor": AccountOutboundSignatureEditorController,
  "password-minimum-hint": PasswordMinimumHintController,
  "password-toggle": PasswordToggleController,
  "landing": LandingController,
  "global-assistant": GlobalAssistantController,
  "global-assistant-splitter": GlobalAssistantSplitterController,
  "changelog-scroll": ChangelogScrollController,
  "property-section": PropertySectionController,
  "changelog-video": ChangelogVideoController,
  "delayed-redirect": DelayedRedirectController,
  "ticket-overflow-marquee": TicketOverflowMarqueeController,
})) {
  application.register(identifier, controller);
}

window.Stimulus = application;
window.ElronStimulusController = Controller;
window.dispatchEvent(new CustomEvent("elron:stimulus-ready"));
